import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from "@nuxtjs/composition-api";
import { useMobile } from "~/core/composables/useMobile";
import { PURCHASE_STEPS } from "~/core/types/purchase-popup-2/PurchaseSteps";
import { FinishReasonEnum } from "~/core/types/purchase-popup-2/FinishReasonEnum";

interface Props {
    visible?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Purchase',
  props: {
    visible: { type: Boolean }
  },
  emits: ['input', 'onPopupClose'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible?: boolean };





const {
    visible,
} = toRefs(props);

const context = useContext();
const isMobile = useMobile();

const internalVisible = ref(visible.value);
const previousStep = ref(-1);
const currentStep = ref(PURCHASE_STEPS.SELECT_PRODUCT_OWNER);
const finishReason = ref(FinishReasonEnum.CLOSED_BY_USER);

const user = computed(() => context.store.getters['application/driver/authUser']);
const purchase = computed(() => context.store.getters['application/purchase-control/purchase']);
const externalPayment = computed(() => context.store.getters['application/purchase-control/externalPayment']);

const handleStepChanged = (step: number) => {
    previousStep.value = currentStep.value;
    currentStep.value = step;
}

const handleClosePurchasePopup = () => {
    const finish = finishReason.value;
    let step: any = currentStep;
    if (currentStep.value === PURCHASE_STEPS.TRANSACTION_REJECTED) {
        step = previousStep.value;
    }

    context.store.dispatch('application/purchase-control/hide', {
        finishReason: finish,
        step,
    });

    $emit('onPopupClose');
}

const updateFinishReason = (reason: FinishReasonEnum) => {
    finishReason.value = reason;
}

watch(visible, (value) => {
    internalVisible.value = value;
});

watch(internalVisible, (value) => {
    if (value === visible.value) {
        return;
    }
    $emit('input', value);
});

return { __sfc: true,props, $emit, visible, context, isMobile, internalVisible, previousStep, currentStep, finishReason, user, purchase, externalPayment, handleStepChanged, handleClosePurchasePopup, updateFinishReason, PURCHASE_STEPS }
}

})